import { ReactComponent as ActivityLog } from "Assets/Icons/PharmsmartIcon/ActivityLogs.svg";
import { ReactComponent as HomeIcon } from "Assets/Icons/PharmsmartIcon/Home.svg";
import { ReactComponent as SurgeryToolsIcons } from "Assets/Icons/PharmsmartIcon/surgeryTools.svg";
import { ReactComponent as PharmacyIcon } from "Assets/Icons/PharmsmartIcon/pharmacy.svg";
import { ReactComponent as GroupIcon } from "Assets/Icons/PharmsmartIcon/GroupIcon.svg";
import { ReactComponent as StaffIcon } from "Assets/Icons/PharmsmartIcon/AddStaffIcon.svg";
import { ReactComponent as CopyCocumentIcon } from "Assets/Icons/PharmsmartIcon/CollectionList.svg";
import { ReactComponent as PrescriptionIcon } from "Assets/Icons/PharmsmartIcon/file-spreadsheet.svg";
import { ReactComponent as EventIcon } from "Assets/Icons/PharmsmartIcon/ReapetOrder.svg";
import { ReactComponent as DispenseDaily } from "Assets/Icons/PharmsmartIcon/DispenseDaily.svg";
import { ReactComponent as DispenseTwiceWeek } from "Assets/Icons/PharmsmartIcon/DispenseTwiceWeek.svg";
import { ReactComponent as DispenseWeekly } from "Assets/Icons/PharmsmartIcon/DispenseWeekly.svg";
import { ReactComponent as DispenseThriceWeek } from "Assets/Icons/PharmsmartIcon/DispenseThriceWeek.svg";
import { ReactComponent as DispenseFortnightly } from "Assets/Icons/PharmsmartIcon/DispenseFortnightly.svg";
import { ReactComponent as SurgeryHomeIcon } from "Assets/Icons/PharmsmartIcon/surgeryTools.svg";
import { ReactComponent as PharmacyHomeIcon } from "Assets/Icons/PharmsmartIcon/PharmacyHomeIcon.svg";
import { ReactComponent as StaffHomeIcon } from "Assets/Icons/PharmsmartIcon/patient.svg";
import { ReactComponent as PatientHomeIcon } from "Assets/Icons/PharmsmartIcon/PatientHomeIcon.svg";
import { ReactComponent as RepeatOrderHomeIcon } from "Assets/Icons/PharmsmartIcon/ReapetOrder.svg";
import { ReactComponent as GroupIconHome } from "Assets/Icons/PharmsmartIcon/GroupIcon.svg";
import { ReactComponent as UncollectedIcon } from "Assets/Icons/PharmsmartIcon/Uncollected.svg";
import { ReactComponent as CollectedIcon } from "Assets/Icons/PharmsmartIcon/Collected.svg";
import { ReactComponent as GapHomeIcon } from "Assets/Icons/PharmsmartIcon/GapHomeIcon.svg";
import { ReactComponent as SYNCHome } from "Assets/Icons/PharmsmartIcon/SYNCHome.svg";
import { ReactComponent as ChaseUpHomeIcon } from "Assets/Icons/PharmsmartIcon/Award.svg";
import { ReactComponent as SettingIcon } from "Assets/Icons/PharmsmartIcon/settings.svg";
import { ReactComponent as ContactSupportIcon } from "../Assets/Icons/PharmsmartIcon/Howto.svg";
import { ReactComponent as Patient } from "Assets/Icons/PharmsmartIcon/patient.svg";
import { ReactComponent as Calender } from "Assets/Icons/DashboardIcons/Calender.svg";
import { ReactComponent as StopWatch } from "Assets/Icons/DashboardIcons/StopWatch.svg";
import { ReactComponent as SearchDoc } from "Assets/Icons/DashboardIcons/SearchDoc.svg";
import { ReactComponent as Patients } from "Assets/Icons/DashboardIcons/Patient.svg";
import { ReactComponent as Repeat } from "Assets/Icons/DashboardIcons/Repeat.svg";
import { ReactComponent as Hourglass } from "Assets/Icons/DashboardIcons/Hourglass.svg";
import { ReactComponent as NursingIcone } from "../Assets/Icons/PharmsmartIcon/NursingIcone1.svg";
import { ucwords } from "./generalUtils";


/**START : Header Menu List */
const profileMenuItem = [
  {
    value: "Logout",
    key: "logout",
    url: "/login",
  },
];

/**START : Side Bar Menu List */
const sidebarMenuItems = [
  {
    icon: HomeIcon,
    value: "Dashboard",
    key: "home",
    url: "/home",
    permission: {
      user: 1,
      pharmacist: 1,
      pharmacist_staff: 1,
      super_admin: 1,
      pharmacy: 1,
      nursing: 0,
    },
  },
  {
    icon: EventIcon,
    value: "Repeat Orders",
    key: "order",
    url: "/order",
    getTitle: function () {
      const query = new URLSearchParams(window.location.search);
      const allowPatientActionTypes = ["create", "edit"];
      const currentPageType =
        allowPatientActionTypes.indexOf(query.get("actionType")) === -1
          ? "Repeat Orders"
          : "Order";
      let title = "order-pad".includes(query.get("orderMethod"))
        ? "Orderpad Collection"
        : query.get("actionType")
          ? `${query.get("actionType")} ${currentPageType}`
          : currentPageType;
      return ucwords(title.trim());
    },
    permission: {
      user: 1,
      pharmacist: 1,
      pharmacist_staff: 1,
      super_admin: 1,
      pharmacy: 1,
      nursing: 1,
    },
  },
  ...(process.env.REACT_APP_USE_PRESCRIPTION_TRACKING == "true"
    ? [
      {
        icon: PrescriptionIcon,
        value: "Prescription Tracking",
        key: "prescription_tracking",
        url: "/prescription-tracking",
        getTitle: function () {
          let width = window.innerWidth;
          const query = new URLSearchParams(window.location.search);
          const allowActionType = ["mark-as-archived"];
          const currentPageType =
            allowActionType.indexOf(query.get("actionType")) > -1
              ? width > 429
                ? "Archived Outstanding List"
                : "Archived List"
              : "Prescription Tracking";
          return ucwords(currentPageType.trim());
        },
        getSubTitle: function () {
          return "Track repeat prescriptions that have been ordered and monitor what's still outstanding.";
        },
        permission: {
          user: 1,
          pharmacist: 1,
          pharmacist_staff: 1,
          super_admin: 1,
          pharmacy: 1,
          nursing: 0,
        },
      },
    ]
    : [
      {
        icon: CopyCocumentIcon,
        value: "Waiting List",
        key: "collection_list",
        url: "/rx-collection",
        getTitle: function () {
          let width = window.innerWidth;
          const query = new URLSearchParams(window.location.search);
          const allowActionType = ["mark-as-archived"];
          const currentPageType =
            allowActionType.indexOf(query.get("actionType")) > -1
              ? width > 429
                ? "Archived Collection List"
                : "Archived List"
              : "Waiting List";
          return ucwords(currentPageType.trim());
        },
        permission: {
          user: 1,
          pharmacist: 1,
          pharmacist_staff: 1,
          super_admin: 1,
          pharmacy: 1,
          nursing: 0,
        },
      },
    ]),
  {
    icon: GroupIcon,
    value: "Groups",
    key: "groups",
    url: "/groups",
    permission: {
      user: 1,
      pharmacist: 1,
      pharmacist_staff: 1,
      super_admin: 1,
      pharmacy: 1,
      nursing: 0,
    },
  },
  {
    icon: SurgeryToolsIcons,
    value: "Surgeries",
    key: "surgeries",
    url: "/surgery",
    permission: {
      user: 1,
      pharmacist: 1,
      pharmacist_staff: 1,
      super_admin: 1,
      pharmacy: 1,
      nursing: 0,
    },
  },

  {
    icon: StaffIcon,
    value: "Staff",
    key: "staff",
    url: "/staff",
    getTitle: function () {
      const query = new URLSearchParams(window.location.search);
      let title = "activity".includes(query.get("actionType"))
        ? "Activity Log"
        : "Staff";
      return ucwords(title.trim());
    },
    permission: {
      user: 0,
      pharmacist: 0,
      pharmacist_staff: 0,
      super_admin: 1,
      pharmacy: 1,
      nursing: 0,
    },
  },

  {
    icon: PharmacyIcon,
    value: "Pharmacies",
    key: "pharmacies",
    url: "/pharmacies",
    permission: {
      user: 0,
      pharmacist: 0,
      pharmacist_staff: 0,
      super_admin: 1,
      pharmacy: 0,
      nursing: 0,
    },
  },

  {
    icon: Patient,
    value: "Patients",
    key: "patients",
    url: "/patients",
    getTitle: function () {
      const query = new URLSearchParams(window.location.search);
      const allowPatientActionTypes = ["create", "edit"];
      const currentPageType =
        allowPatientActionTypes.indexOf(query.get("actionType")) === -1
          ? "patients"
          : "RX";
      let title = "import-patient".includes(query.get("actionType"))
        ? "Import Patient"
        : query.get("actionType")
          ? `${query.get("actionType")} ${currentPageType}`
          : currentPageType;
      return ucwords(title.trim());
    },
    permission: {
      user: 1,
      pharmacist: 1,
      pharmacist_staff: 1,
      super_admin: 1,
      pharmacy: 1,
      nursing: 0,
    },
  },
  {
    icon: ActivityLog,
    value: "Activity Log",
    key: "algorithm",
    url: "/activity",
    permission: {
      user: 1,
      pharmacist: 1,
      pharmacist_staff: 1,
      super_admin: 1,
      pharmacy: 1,
      nursing: 0,
    },
  },
  {
    icon: ActivityLog,
    value: "Payment Log",
    key: "payment_list",
    url: "/payment-log",
    permission: {
      user: 0,
      pharmacist: 0,
      pharmacist_staff: 0,
      super_admin: 0,
      pharmacy: 1,
      nursing: 0,
    },
  },
  {
    icon: ActivityLog,
    value: "Duplicate Patient",
    key: "patients",
    url: "/duplicate-patient",
    permission: {
      user: 1,
      pharmacist: 1,
      pharmacist_staff: 1,
      super_admin: 0,
      pharmacy: 1,
      nursing: 0,
    },
  },
  {
    icon: ContactSupportIcon,
    value: "How To?",
    key: "how_to",
    url: "/how-to",
    permission: {
      user: 1,
      pharmacist: 1,
      pharmacist_staff: 1,
      super_admin: 1,
      pharmacy: 1,
      nursing: 0,
    },
  },
  {
    icon: SettingIcon,
    value: "Settings",
    key: "settings",
    url: "/settings",
    permission: {
      user: 1,
      pharmacist: 1,
      pharmacist_staff: 1,
      super_admin: 1,
      pharmacy: 1,
      nursing: 0,
    },
  },
];

/** START : Staff Menu List */
const staffMenuItems = [
  {
    value: "pharmacist",
    label: "Pharmacist",
  },
  {
    value: "pharmacist_staff",
    label: "Pharmacy assistant",
  },
  {
    value: "user",
    label: "Driver",
  },
];

/** Surgery Menu List  */
const surgeryPrimaryOderMenuItems = [
  {
    value: "email",
    label: "Email",
  },
  {
    value: "fax",
    label: "Fax",
  },
  {
    value: "phone",
    label: "Phone",
  },
  {
    value: "other",
    label: "Other",
  },
];

/** Patient Status Menu List  */
const statusMenuItems = [
  {
    value: "active",
    label: "Active",
  },
  {
    value: "absent",
    label: "Absent",
  },
  {
    value: "deceased",
    label: "Deceased",
  },
  {
    value: "in_hospital",
    label: "In-Hospital",
  },
];
/** Patient Status Menu List  */
const FileTypeItems = [
  // {
  //   value: "default",
  //   label: "Demo CSV",
  // },
  {
    value: "proscript",
    label: "Proscript",
  },
  {
    value: "rxweb",
    label: "RxWeb",
  },
  {
    value: "titan",
    label: "Titan",
  },
  {
    value: "mps",
    label: "MPS ",
  },
];
const importType = [
  {
    key: "mps",
    value: "MPS_Export_Instructions",
    label: "MPS Export Instructions",
    link: "https://docs.google.com/document/d/1A-p9FTtEGgvkUeG63r83xnLZ3rFoJDtFQwjhpAc4ozE/edit?usp=sharing&embedded=true&rm=minimal",
  },
  {
    key: "proscript",
    value: "Proscript_Export_Instructions",
    label: "Proscript Export Instructions",
    link: "https://docs.google.com/document/d/1sb7sxUf_P7rm7wtRpsdc2Ix9KWZ8oeGx1Wwcw7ohGG8/edit?usp=sharing&embedded=true&rm=minimal",
  },
  {
    key: "rxweb",
    value: "RxWeb_Export_Instructions",
    label: "RxWeb Export Instructions",
    link: "https://docs.google.com/document/d/1CJiacHjCFVesVwK-hRIzp08-4RpvtwhWb1zoUtXtsQ0/edit?usp=sharing&embedded=true&rm=minimal",
  },
  {
    key: "titan",
    value: "titan_export_instructions",
    label: "Titan Export Instructions",
    link: "https://docs.google.com/document/d/1AIPb3-MO0j7AKXNOPUcQxjJrT4Ame54mO2_Um_DugpY/edit?usp=sharing&embedded=true&rm=minimal",
  },
  {
    key: "formate import",
    value: "how_to_format_your_file_for_import_on_repeatsmart",
    label: "How to format your file on Repeatsmart",
    link: "https://docs.google.com/document/d/1VyIrt86WpqQTpVH18LbiAi9AXpya4SwR9qQ7M8DJn-k/edit?usp=sharing&embedded=true&rm=minimal",
  },
  {
    key: "pharmacy",
    value: "pharmacy_manager_export",
    label: "Pharmacy Manager Export",
    link: "https://docs.google.com/document/d/1OiNFkW_SEwKrSUI5LJYehkPL6ChpSiiQ-zxrZB0mG_4/edit?usp=sharing&embedded=true&rm=minimal",
  },
  {
    key: "analyst_export",
    value: "analyst_export",
    label: "Analyst Export",
    link: "https://docs.google.com/document/d/1RkHwHMLq6_EglXmvuf3CD8WFQDfSXcIY2rfDxF6T--8/edit?usp=sharing&embedded=true&rm=minimal",
  },
  {
    key: "otherprm",
    value: "other_pmr_exports",
    label: "Other PMR Exports",
    link: "https://docs.google.com/document/d/1ixzfQfakFTlYPBXZMj8RppwWRsSGns0970njUR57UFo/edit?usp=sharing&embedded=true&rm=minimal",
  },
];
/** Patient Type Menu List */
const patientTypeMenuItems = [
  {
    value: "delivery",
    label: "Delivery",
  },
  {
    value: "collection",
    label: "Collection",
  },
];

/** Install Dispensing Menu List */
const InstallmentDispensing = [
  {
    value: "weekly",
    label: "Dispense Weekly",
  },
  {
    value: "daily",
    label: "Dispense daily",
  },
  {
    value: "twice_weekly",
    label: "Dispense twice Weekly",
  },
  {
    value: "fortnightly",
    label: "Dispense fortnightly",
  },
  {
    value: "three_times_a_week",
    label: "Dispense three time a  Week",
  },
];

/** Install Dispensing Details */
const InstallmentDispensingDetail = {
  daily: {
    value: "daily",
    label: "Dispense daily",
    icon: DispenseDaily,
  },
  weekly: {
    value: "weekly",
    label: "Dispense Weekly",
    icon: DispenseWeekly,
  },
  twice_weekly: {
    value: "twice_weekly",
    label: "Dispense twice Weekly",
    icon: DispenseTwiceWeek,
  },
  three_times_a_week: {
    value: "three_times_a_week",
    label: "Dispense three time a  Week",
    icon: DispenseThriceWeek,
  },
  fortnightly: {
    value: "fortnightly",
    label: "Dispense fortnightly",
    icon: DispenseFortnightly,
  },
};

/** Week Menu List */
const weeksList = [
  {
    value: 7,
    label: "7 days",
  },
  {
    value: 14,
    label: "14 days",
  },
  {
    value: 28,
    label: "28 days",
  },
  {
    value: 56,
    label: "56 days",
  },
  {
    value: 84,
    label: "84 days",
  },
  {
    value: 0,
    label: "Custom",
  },
];

/** Order Gap List */
const orderGapList = [
  {
    value: 28,
    label: "28 days",
  },
  {
    value: 21,
    label: "21 days",
  },
  {
    value: 14,
    label: "14 Days",
  },
  {
    value: 10,
    label: "10 days",
  },
  {
    value: 7,
    label: "7 days",
  },
];

/** Preferred Order Day List */
const PreferredOrderDay = [
  {
    value: "Monday",
    label: "Monday",
  },
  {
    value: "Tuesday",
    label: "Tuesday",
  },
  {
    value: "Wednesday",
    label: "Wednesday",
  },
  {
    value: "Thursday",
    label: "Thursday",
  },
  {
    value: "Friday",
    label: "Friday",
  },
];

/** DashBoard Box List */
const dashboardWidget = {
  chase_up: {
    icon: SearchDoc,
    link: process.env.REACT_APP_USE_PRESCRIPTION_TRACKING == "true" ? "prescription-tracking" : "rx-collection",
    background: "#DEE5EE",
    boxColor: "#7bbd4b",
    countColor: "#6686B6",
    BackgroundBoxColor: "#2C8AE7",
    setCollection: "un_collected",
    chaseUp: true,
  },
  surgeries_list: {
    icon: SurgeryHomeIcon,
    link: "surgery",
    boxColor: "#7bbd4b",
    background: "#F0F5FB",
    countColor: "#4297FE",
    BackgroundBoxColor: "#fb892c",
    navLabel: "",
  },
  pharmacies_list: {
    icon: PharmacyHomeIcon,
    link: "pharmacies",
    background: "#FBF0FB",
    countColor: "#FE63FE",
    boxColor: "#7bbd4b",
    BackgroundBoxColor: "#E33280",
    navLabel: "",
  },
  staff_list: {
    icon: PatientHomeIcon,
    link: "staff",
    background: "#F0F0FB",
    countColor: "#7C7CFA",
    boxColor: "#7bbd4b",
    BackgroundBoxColor: "#E33280",
    navLabel: "",
  },
  patient_list: {
    icon: Patients,
    link: "patients",
    background: "#FBF0F2",
    countColor: "#FD889D",
    boxColor: "#7bbd4b",
    BackgroundBoxColor: "#26bdc3",
  },
  order_list: {
    icon: Repeat,
    link: "order?dashboard=true",
    background: "#E4FFF9",
    countColor: "#7ED1BF",
    boxColor: "#7bbd4b",
    BackgroundBoxColor: "#E33280",
  },
  group_list: {
    icon: GroupIconHome,
    link: "groups",
    background: "#E6F6FF",
    countColor: "#23B0FF",
    boxColor: "#7bbd4b",
    BackgroundBoxColor: "#87AE4C",
    navLabel: "",
  },
  Collected_list: {
    icon: CollectedIcon,
    link: process.env.REACT_APP_USE_PRESCRIPTION_TRACKING == "true" ? "prescription-tracking" : "rx-collection",
    background: "#FFF8EC",
    countColor: "#FFB83E",
    setCollection: "collected",
    boxColor: "#7bbd4b",
    BackgroundBoxColor: "#E33280",
    navLabel: "",
  },
  uncollected_list: {
    icon: Hourglass,
    link: process.env.REACT_APP_USE_PRESCRIPTION_TRACKING == "true" ? "prescription-tracking" : "rx-collection",
    background: "#F5EEFF",
    countColor: "#A465FF",
    setCollection: "un_collected",
    boxColor: "#7bbd4b",
    BackgroundBoxColor: "#F4B300",
  },
  oos_list: {
    icon: SYNCHome,
    link: "order",
    background: "#EBFFE4",
    countColor: "#75C25B",
    boxColor: "#7bbd4b",
    BackgroundBoxColor: "#F4B300",
    navLabel: "",
  },
  order_gap: {
    icon: GapHomeIcon,
    link: "order?warnings=true",
    background: "#FFF3F3",
    countColor: "#FF6C6C",
    boxColor: "#7bbd4b",
    BackgroundBoxColor: "#1B9A55",
    navLabel: "",
  },

  // New Added
  todays_orders: {
    icon: Calender,
    link: "order",
    background: "#FFF3F3",
    countColor: "#FF6C6C",
    boxColor: "#7bbd4b",
    BackgroundBoxColor: "#1B9A55",
  },
  urgent_rxs: {
    icon: StopWatch,
    link: "order",
    background: "#FFF3F3",
    countColor: "#FF6C6C",
    boxColor: "#7bbd4b",
    BackgroundBoxColor: "#4E4EDB",
  },
};

const helpMenuList = [
  // {
  //   link: "https://www.loom.com/embed/eac968353cd6457f8cfdce5fa4102d30",
  //   title: "Importing patients from your PMR",
  //   id: "import_prm",
  //   is_video: true,
  // },
  // {
  //   link: "https://www.loom.com/embed/0b68bf67798547bdae786535aabb49a4",
  //   title: "Activating Patients",
  //   id: "activing_patients",
  //   is_video: true,
  // },
  // {
  //   link: "https://www.loom.com/embed/168de9417012488db94df6af9977d43f",
  //   title: "Create Surgery / Create Patient",
  //   id: "create_surgery_patient",
  //   is_video: true,
  // },
  // {
  //   link: "https://www.loom.com/embed/b5fd1564d2c646f5b251863289882580",
  //   title: "Create Orders",
  //   id: "create_order",
  //   is_video: true,
  // },
  // {
  //   link: "https://www.loom.com/embed/ffac235ee34e4d7a820aa2c50762a423",
  //   title: "Send Orders",
  //   id: "send_orders",
  //   is_video: true,
  // },
  // {
  //   link: "https://www.loom.com/embed/648f88d2779c461f97bf8a32297dbdfb",
  //   title: "Creating Groups",
  //   id: "creating_group",
  //   is_video: true,
  // },
  // {
  //   link: "https://www.loom.com/embed/57549a55a2cb43e08df497e2e7333208",
  //   title: "Settings",
  //   id: "setting",
  //   is_video: true,
  // },

  // {
  //   link: "https://www.loom.com/embed/91df2cc936854356a03f79d68210e74a",
  //   title: "Collection List",
  //   id: "collection_list",
  //   is_video: true,
  // },
  // {
  //   title: "Contact Us",
  //   id: "contact",
  //   is_video: false,
  // },
  {
    title: "Account/Billing",
    id: "billing",
  },
  {
    title: "User Guide & Training videos",
    id: "guide",
    navigation: "/how-to",
  },
  {
    title: "Contact Us",
    id: "contact",
  },
];

// Data for Bar Chart in Dashboard

const newHomeList = [
  {
    key: "todays_orders",
    label: "Today's Orders",
    count: 24,
    navLabel: "View today’s orders",
    todayLabel: "15 sent today already",
  },
  {
    key: "chase_up",
    label: "Rxs to chase up ",
    count: "05",
    navLabel: "View chase ups",
    todayLabel: "7 chased up today",
  },
  {
    key: "urgent_rxs",
    label: "Urgent Rxs",
    count: "06",
    navLabel: "View urgent Rxs",
    todayLabel: "0 urgent Rxs added today",
  },

  {
    key: "patient_list",
    label: "Patients",
    count: 1056,
    navLabel: "View patients",
  },
  {
    key: "order_list",
    label: "Repeat Orders",
    count: 486,
    navLabel: "View repeat orders",
  },
  {
    key: "uncollected_list",
    label: "Waiting Rxs",
    count: 39,
    navLabel: "View Prescription Tracking",
  },

  // { key: 'surgeries_list', label: 'Surgeries', count: 280 },
  // { key: 'group_list', label: 'Groups', count: 84 },
  // { key: 'oos_list', label: 'Out of Sync', count: 288 },
  // { key: 'order_gap', label: 'Order Gap', count: 271 },
  // { key: 'pharmacies_list', label: 'Pharmacies', count: 118 },
  // { key: 'staff_list', label: 'Staff', count: 68 },
  // { key: 'Collected_list', label: 'Collected RXs', count: 7 },

  {
    key: "surgeries_list",
    label: "Surgeries",
    count: 280,
    navLabel: "View surgeries",
  },
  { key: "group_list", label: "Groups", count: 84, navLabel: "View groups" },
  {
    key: "oos_list",
    label: "Out of Sync",
    count: 288,
    navLabel: "View out of sync orders",
  },
  {
    key: "order_gap",
    label: "Order Gap",
    count: 271,
    navLabel: "View order gap",
  },
  {
    key: "pharmacies_list",
    label: "Pharmacies",
    count: 118,
    navLabel: "View pharmacies",
  },
  { key: "staff_list", label: "Staff", count: 68, navLabel: "View staff" },
  {
    key: "Collected_list",
    label: "Collected RXs",
    count: 7,
    navLabel: "View Collected rxs",
  },
];

export {
  profileMenuItem,
  sidebarMenuItems,
  surgeryPrimaryOderMenuItems,
  staffMenuItems,
  statusMenuItems,
  weeksList,
  patientTypeMenuItems,
  InstallmentDispensing,
  InstallmentDispensingDetail,
  orderGapList,
  PreferredOrderDay,
  dashboardWidget,
  importType,
  helpMenuList,
  FileTypeItems,
  newHomeList,
};
